var rich_content_viewer_default = {
  "fontElementMap": "EEiWf",
  "wrapper": "Y9hzn",
  "pluginContainerMobile": "_0e-ZS",
  "viewer": "qlhuS",
  "android": "aEuqw",
  "rootedTraversedContent": "B84Eo",
  "atomic": "YMQzz",
  "toolbar": "koyFG",
  "block": "RM4I1"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer.scss.js.map
